var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import MuiDivider from '@material-ui/core/Divider';
/**
 * Kareo wrapped component of the Material-UI Divider. The prop API has been limited to props defined in DividerProps.
 *
 * A divider is a thin line that groups content in lists and layouts.
 *
 * Material-UI Divider: [Docs](https://v4.mui.com/components/dividers/), [API](https://v4.mui.com/api/divider/)
 *
 * @storybook: [Divider](http://design.kareoprod.ent/design-system/?path=/story/components-inputs--Divider-example)
 */
var Divider = function (props) {
    return React.createElement(MuiDivider, __assign({}, props));
};
Divider.displayName = 'KareoDivider';
export default Divider;
